import React, { useLayoutEffect } from "react"
import { useArticleNavigation } from "../../../../hooks";
import { createArticleTopics } from "./utils";
import { 
  StyledArticleVerticalNavigationWrapper,
  StyledArticleMainSubjectsList,
  StyledArticleMainSubjectListItem
} from "./styled"

const SidebarNavigation = ({ articleTopics, setSelectedItem  }) => {
  const activeItem = useArticleNavigation(articleTopics);

  useLayoutEffect(() => {
    createArticleTopics();
  }, []);

  return (
    <StyledArticleVerticalNavigationWrapper>
      <StyledArticleMainSubjectsList>
        {articleTopics.map(({ innerText }, index) => (
          <StyledArticleMainSubjectListItem
            id={`article-section-h2-${index}`}
            isActive={activeItem === index}
            onClick={() => setSelectedItem(`article-section-h2-${index}`)}
          >
            {innerText}
          </StyledArticleMainSubjectListItem>
        ))}
      </StyledArticleMainSubjectsList>
    </StyledArticleVerticalNavigationWrapper>
  )
}

export default SidebarNavigation
